import { Button, Container, FormControl } from "@airbus/components-react";
import React, { useEffect, useState } from "react";
import { MobileView } from "react-device-detect";


const InstallPWA = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    const handler = e => {
      e.preventDefault();
      console.log("we are being triggered :D");
      setSupportsPWA(true);
      setPromptInstall(e);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("transitionend", handler);
  }, []);

  const onClick = evt => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };
  if (!supportsPWA) {
    return null;
  }
  return (
    <MobileView>
    <Container until="sm" style={{marginTop:"20px"}}>
        <FormControl>
            <Button
            className="link-button"
            id="setup_button"
            aria-label="Install app"
            title="Installer SAJM Admin sur mobile"
            onClick={onClick}
            >
            Installer l'application sur mon mobile
            </Button>
        </FormControl>
    </Container>
    </MobileView>
  );
};

export default InstallPWA;